<template v-if="interactionMode === 'select'">
  <ol-interaction-select ref="selectInteraction" 
  :condition="selectCondition" 
  :filter="selectInteractionFilter">
    <vector-styles :selected="true" />
  </ol-interaction-select>

  <ol-interaction-pointer v-if="selectedOLFeature && interactionMode !== 'edit'" @drag="clearOnDrag"
      @down="clearOnDrag" />
</template>

<script setup>
import { ref, onMounted, inject } from "vue"
import VectorStyles from "@/components/map/layers/VectorStyles.vue"

let interactionMode = null

const emit = defineEmits(["zoomToFeature"])

const hitTolerance = 20

const singleClickWithTolerance = function (e, a, b) {
  if (e.type !== "singleclick") return
  if (interactionMode.value !== 'select') return



  // console.log(e)
  // console.log(a)
  // console.log(b)
  let hit = false
  //   if (!map_ref.value) {
  //     console.log("map_ref not ready")
  //     return
  //   }

  map_ref.value.forEachFeatureAtPixel(
    e.pixel,
    function (feature, layer) {

      // console.log(layer)
      let layerProperties = layer.get("properties")

      if (typeof layerProperties === "function") {
        layerProperties = layerProperties()
      }

      // console.log(layerProperties)
      const selectable = layerProperties?.["selectable"]
      if (selectable === false) {
        return false
      }

      hit = true
      actions.selectFeature(feature)

      // console.log(feature)

      return true // stop feature detection in forEachFeatureAtPixel (only one feature, see docs)

    },
    {
      hitTolerance: hitTolerance,
    },
  )

  if (!hit) {
    if (interactionMode !== 'edit') {
      console.log("vs clearing selection 1")
      actions.clearSelection()
    }
  }

  // if (hit) {
  //   console.log("hit")
  //   return featureFound
  // } else {
  //   console.log("miss")
  //   return false
  // }
  // feature.changed()
}




// const selectConditions = inject("ol-selectconditions")
// const singleClickSelectCondition = selectConditions.singleClick
const selectCondition = singleClickWithTolerance

// console.log(selectConditions)
// console.log(singleClickSelectCondition)



const selectedOLFeature = defineModel("selectedOLFeature")

const layerOfSelectedFeature = defineModel("layerOfSelectedFeature")


selectedOLFeature.value = null

const selectInteraction = ref(null)
const map_ref = ref(null)
const view_ref = ref(null)

const actions = {}

actions.clearSelection = function () {
  selectInteraction.value?.select.getFeatures().clear()
  selectedOLFeature.value = null
}

const clearOnDrag = function () {
  console.log("interactionMode: ", interactionMode.value) 
  console.log("clearOnDrag")  
  actions.clearSelection()
}

const featureCount = ref(0)


// actions.selectFeature = function (layer, feature) {  
actions.selectFeature = (feature) => {

  if (!selectInteraction.value) {
    console.log("selectInteraction not ready")
    console.log(selectInteraction)
    return
  }

  selectInteraction.value.select.getFeatures().clear()
  selectInteraction.value.select.getFeatures().push(feature)
  layerOfSelectedFeature.value = selectInteraction.value.select.getLayer(feature)
  selectedOLFeature.value = feature
  //centerOnFeature(view_ref, feature)

  emit('zoomToFeature', feature)

  featureSelected(feature)
}




const featureSelected = (feature) => {

  const selectedFeature = feature

  selectedOLFeature.value = selectedFeature


  // console.log(selectInteraction)
  // console.log(selectInteraction.value)
  // console.log(selectInteraction.value.select)
  // console.log(selectInteraction.value.select.getLayer(selectedFeature))

  layerOfSelectedFeature.value = selectInteraction.value.select.getLayer(selectedFeature)  // non reactive here

  const features = selectInteraction.value.select.getLayer(selectedFeature)?.get("source")?.getFeatures()
  // console.log(features)
  // const count = features.length

  featureCount.value = features.length


  //centerOnFeature(view_ref, selectedFeature)

  emit('zoomToFeature', selectedFeature)



}

const selectInteractionFilter = (feature, layer) => {


  if (selectedOLFeature?.value?.ol_uid === feature.ol_uid) {   // unselect
    actions.clearSelection()
    return false
  }


  if (selectedOLFeature) {   // unique selection
    actions.clearSelection()
  }


  // console.log(layer)
  const properties = layer.get("properties")()   // properties must be a function
  // console.log(properties)


  const selectable = properties["selectable"]
  // console.log("selectable: ",selectable)


  if (selectable === false) {
    return false
  }


  return true


}


defineExpose({ actions })


onMounted(() => {
  map_ref.value = selectInteraction.value.select.getMap()
  view_ref.value = map_ref.value.getView()
  interactionMode = inject("interactionMode")
})


</script>
